// extracted by mini-css-extract-plugin
export default {"hideLabel":"language-toggle_hideLabel__eeN4f"};